import { Component, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { WgisService } from './wgis.service';
import { WGisDisplayMode } from './wgis.utils';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-map',
  templateUrl: './wgis.map.component.html',
  styleUrls: ['./wgis.map.component.css']
})
export class WgisMapComponent implements AfterViewInit {

  public isSmallScreen: boolean = false;
  @ViewChild('list_layers', {static: false}) layers: ElementRef;
  
  constructor(private wgisservice: WgisService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      switch (mode) {
        case WGisDisplayMode.Invisible: {
          this.show(false);
          break;
        }
        case WGisDisplayMode.Full: {
          // this.show(true);
          this.showFull();
          break;
        }
        case WGisDisplayMode.Right: {
          // this.show(true);
          this.showRight();
          break;
        }
        case WGisDisplayMode.Left: {
          // this.show(true);
          this.showLeft();
          break;
        }
      }
    });
  }

  show(val: boolean) {
    if (val) {
      this.setclass('wgis-show wgis-full wgis-top0 wgis-left0');

    } else {
      this.setclass('wgis-hide');
    }
    this.wgisservice.wgisRefresh.emit(true);
  }

  showFull() {
    this.setclass('wgis-show wgis-full wgis-top0 wgis-left0');
    this.wgisservice.wgisRefresh.emit(true);
  }
  showLeft() {
    this.setclass('wgis-show wgis-half-v wgis-top0 wgis-left0');
    this.wgisservice.wgisRefresh.emit(true);
  }

  showRight() {
    this.setclass('wgis-show wgis-half-v wgis-top0 wgis-right0');
    this.wgisservice.wgisRefresh.emit(true);
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);

    this.setclass('wgis-hide');
    this.wgisservice.setDiv('map');
    this.wgisservice.addControlByElement(this.layers.nativeElement);
  }

  setclass(classname: string) {
    const element = document.getElementById('map');
    element.className = classname;
  }

}
